type TabWithEndpointIdentity = {
  id?: unknown;
  data?: unknown;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const extractEndpointIdFromTab = ({
  tab,
}: {
  tab: TabWithEndpointIdentity;
}): string | undefined => {
  const tabData = isRecord(tab.data) ? tab.data : undefined;

  if (tabData && typeof tabData.endpointId === 'string') {
    return tabData.endpointId;
  }

  if (tabData && typeof tabData.id === 'string') {
    return tabData.id;
  }

  if (tabData && typeof tabData.entityId === 'string') {
    return tabData.entityId;
  }

  return undefined;
};
